import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import styles from './styles';

export default function NotFound(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="outer-container">
      <div className="background">
        <div className="overlay" />
      </div>
      <div className="content container">
        <div className="row">
          <div className="col-lg-12">
            <h1 dangerouslySetInnerHTML={{ __html: t('notFound.title') }} />
            <p dangerouslySetInnerHTML={{ __html: t('notFound.subtitle') }} />
            <div className="button-container">
              <Link href={'/'}>
                <a className="button">{t('notFound.return')} Autolist.com</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
